import { type ReactNode } from 'react';

function Marker({ pct, label }: { pct: number; label: string }): ReactNode {
  return (
    <div
      className="absolute -top-1 flex flex-col items-center -translate-x-1/2"
      style={{ left: `${pct}%` }}
    >
      <div className="h-4 w-0.5 rounded-full bg-brand-red" />
      <span className="mt-1 whitespace-nowrap text-[11px] font-bold text-brand-red">
        {label}
      </span>
    </div>
  );
}

type Props = { accumulated: number; threshold: number };

export function MilestoneBar({ accumulated, threshold }: Props): ReactNode {
  const scale = Math.max(accumulated, threshold) * 1.4;
  const fillPct = (accumulated / scale) * 100;
  const markerPct = (threshold / scale) * 100;
  return (
    <div className="relative mt-sm pb-4">
      <div className="h-2 w-full overflow-hidden rounded-full bg-white/[0.06]">
        <div
          className="h-full rounded-full bg-brand-red transition-all duration-700"
          style={{ width: `${fillPct}%` }}
        />
      </div>
      <Marker pct={markerPct} label={`$${Math.round(threshold)}`} />
    </div>
  );
}
